"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
const Leaf = __importStar(require("leaf-ts"));
const web_consensus_1 = require("@branch-ts/web-consensus");
const notFound_html_R_1 = require("./notFound.html.R");
const notFound_html_R_2 = require("./notFound.theme/business/notFound.html.R");
class NotFound extends notFound_html_R_1.R.NotFound {
    constructor() {
        super(...arguments);
        this.uri = "";
        this.present = web_consensus_1.PresentMechanism.ensure(this).requireConfig().lifeCycle(async (about) => {
            const option = await about.declare("configure");
            this.uri = option.uri;
            this.VM.uri = option.uri;
            await about.declare("present");
            await about.declare("hang");
            await about.declare("dismiss");
        });
    }
    onClickReturnHome() {
        web_consensus_1.UIMechanism.goHome();
    }
    onClickCopyURI() {
        void globalThis.navigator?.clipboard?.writeText(this.uri);
    }
}
exports.NotFound = NotFound;
Leaf.WidgetThemeCenter.about(notFound_html_R_1.R.NotFound).add("business", notFound_html_R_2.R.NotFound.generator);
